import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterOperatorTextInput = props => {
  const {
    'data-selenium-test': dataSeleniumTest,
    disabled,
    error,
    inputUse,
    onChange,
    onBlur,
    readOnly,
    value
  } = props;
  const isError = error.get('error');
  const errorMessage = error.get('message');
  return /*#__PURE__*/_jsx(FormControl, {
    "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
    error: isError,
    validationMessage: isError ? errorMessage : null,
    children: /*#__PURE__*/_jsx(TextInput, {
      autoFocus: true,
      "data-selenium-test": dataSeleniumTest,
      disabled: disabled,
      onBlur: onBlur,
      onChange: onChange,
      readOnly: readOnly,
      use: inputUse,
      value: value
    })
  });
};
export default FilterOperatorTextInput;